import React from 'react';

interface BlogJsonLdProps {
  title: string;
  excerpt: string;
  author: string;
  datePublished: string;
  url: string;
  image?: string;
}

const BlogJsonLd: React.FC<BlogJsonLdProps> = ({ title, excerpt, author, datePublished, url, image }) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "headline": title,
    "description": excerpt,
    "author": {
      "@type": "Person",
      "name": author
    },
    "datePublished": datePublished,
    "url": url,
    "image": image || "https://greentick.org.in/og-image.png",
    "publisher": {
      "@type": "Organization",
      "name": "GreenTick AI",
      "logo": {
        "@type": "ImageObject",
        "url": "https://greentick.org.in/logo.png"
      }
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url
    }
  };

  return (
    <script 
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
};

export default BlogJsonLd;
